import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "responses-page" }
const _hoisted_2 = { class: "responses-search" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_back_icon = _resolveComponent("back-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_search_icon = _resolveComponent("search-icon")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_data_table = _resolveComponent("n-data-table")!
  const _component_ConfirmResponseUnlockModal = _resolveComponent("ConfirmResponseUnlockModal")!
  const _component_ConfirmSurveyResend = _resolveComponent("ConfirmSurveyResend")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_n_space, {
        justify: "space-between",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_h1, null, {
            default: _withCtx(() => [
              _createTextVNode("Participants")
            ]),
            _: 1
          }),
          _createVNode(_component_n_button, {
            class: "back",
            onClick: _ctx.navigateToGraph
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_n_icon, {
                size: "17",
                class: "back-icon",
                "aria-hidden": "true"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_icon)
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Back to Graph ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.responsesLoaded)
        ? (_openBlock(), _createBlock(_component_n_input, {
            key: 0,
            autofocus: "",
            type: "text",
            placeholder: "Search",
            value: _ctx.searchQuery,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            clearable: ""
          }, {
            suffix: _withCtx(() => [
              _createVNode(_component_n_icon, { "aria-label": "Search" }, {
                default: _withCtx(() => [
                  _createVNode(_component_search_icon, { "aria-hidden": "true" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.responsesLoaded)
      ? (_openBlock(), _createBlock(_component_n_data_table, {
          key: 0,
          columns: _ctx.columns,
          data: _ctx.filteredData,
          bordered: false,
          pagination: _ctx.pagination,
          class: "responses-list",
          "aria-label": "Responses list"
        }, null, 8, ["columns", "data", "pagination"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmResponseUnlockModal, {
      showModal: _ctx.showUnlockModal,
      "onUpdate:showModal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showUnlockModal) = $event)),
      response: _ctx.selectedResponse,
      onUnlockResponse: _ctx.updateResponsesInList
    }, null, 8, ["showModal", "response", "onUnlockResponse"]),
    _createVNode(_component_ConfirmSurveyResend, {
      showModal: _ctx.showResendModal,
      "onUpdate:showModal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showResendModal) = $event)),
      response: _ctx.selectedResponse
    }, null, 8, ["showModal", "response"])
  ]))
}